const LogsRoutes = [
  // 日志管理
  {
    path: 'logs',
    name: 'Log',
    redirect: '/manage/system/logs/action/login',
    component: () => import(/* webpackChunkName: "SystemRole" */ '@/views/content'),
    meta: {
      sidebar: 2,
      authKey: ['auth_logs'],
      title: 'com_sider_menu_logs',
      disabled: false,
      icon: 'menu_log2',
      breadcrumb: false,
      hasChildrenMenu: true,
      hide: true,
    },
    children: [
      // 操作日志
      {
        path: 'action/:type?/:id?',
        name: 'ActionLogList',
        component: () => import(/* webpackChunkName: "ActionLog" */ '@/views/system/logs/list'),
        meta: {
          sidebar: 2,
          authKey: ['auth_logs', 'auth_logs_action'],
          title: 'com_sider_menu_logs_action',
          disabled: false,
          icon: 'menu_log2',
        },
      },
      // 协议日志
      {
        path: 'protocol',
        name: 'ProtocolLogList',
        component: () => import(/* webpackChunkName: "ActionLog" */ '@/views/system/logs/protocol'),
        meta: {
          sidebar: 2,
          authKey: ['auth_logs', 'auth_logs_protocol'],
          title: 'com_sider_menu_logs_protocol',
          disabled: false,
          icon: 'menu_log2',
        },
      },
      // 错误日志
      {
        path: 'error',
        name: 'ErrorLogList',
        component: () => import(/* webpackChunkName: "ErrorLog" */ '@/views/system/logs/error'),
        meta: {
          sidebar: 2,
          authKey: ['auth_logs', 'auth_logs_error'],
          title: 'com_sider_menu_logs_error',
          disabled: false,
          icon: 'menu_log2',
        },
      },
    ],
  },
];

export default LogsRoutes;
